export interface SocketMessage {
    type: ClientMessageType;
}

export interface SubscribeMessage extends SocketMessage {
    type: ClientMessageType.SUBSCRIBE;
    monitoring: boolean;
    serving: boolean;
}

export enum ClientMessageType {
    SUBSCRIBE,
    OPEN_MODAL,
    CLOSE_MODAL,
    WHATSAPP_SEND,
    ACKNOWLEDGE_PROBLEM
}

export enum ServerMessageType {
    PROBLEMS,
    MODALS,
    MODAL_OPENED,
    MODAL_CLOSED,
    WHATSAPP_SENT_PROBLEMS,
    TICKET_SENT_PROBLEMS,
}